export default __webpack_public_path__ + "static/sleevelami-964f7c32a23b8c1143dd84f18b5a773a.jpg";